import * as R from 'ramda';

import { globalizeSelectors } from 'framework/globalize/utils/index.js';

export const getNotifications = state =>
  R.map(id => state.entities[id], state.ids);

export default globalizeSelectors(['notification_state'], { getNotifications });
